import LogoColor from "assets/images/brands/logoTracbel.png";
import LogoWhite from "assets/images/brands/logoTracbel.png";
export const Wallet = {
  tracbel: {
    name: "Tracbel | Atendimento Online",
    shortname: "Tracbel",
    logo_color: LogoColor,
    logo_white: LogoWhite,
    token: window.chtken,
    color: {
      primary: "#FDBA12",
      secondary: "#fff",
    },
  },
};
